import { useDispatch, useSelector } from 'react-redux';
import { setStatus, batchUpdateStatus } from 'src/redux/slices/wf';

const broadcast = new BroadcastChannel('wf_channel');

export const useWFStatusRedux = () => {
  const dispatch = useDispatch();
  const state = useSelector(state => state.wf);
  const { frontEnd } = useSelector(({ bizMeta }) => bizMeta);
  const isReduxSyncAllowed =
    frontEnd?.redux?.sync ??
    frontEnd?.redux?.local_sync ??
    frontEnd?.socket?.local_sync ??
    false;
  const updateStatus = ({ jid, wfStatus, jStatus }) => {
    const current = state[jid] || {};
    const nextJStatus = jStatus !== undefined ? jStatus : current.jStatus ?? 0;

    if (current.wfStatus === wfStatus && current.jStatus === nextJStatus) {
      return; // No update needed
    }

    dispatch(setStatus({ jid, wfStatus, jStatus }));
    if (isReduxSyncAllowed) {
      broadcast.postMessage({
        type: 'wf_change',
        timestamp: Date.now(),
        jid,
        wfStatus,
        jStatus
      });
    }
  };

  const updateBatchStatus = updates => {
    dispatch(batchUpdateStatus(updates));
    if (isReduxSyncAllowed) {
      broadcast.postMessage({
        type: 'batch_wf_change',
        timestamp: Date.now(),
        updates
      });
    }
  };

  return { updateStatus, updateBatchStatus };
};
export default useWFStatusRedux;
